import { CloseOutlined } from "@ant-design/icons";
import { Button, Space, Tag, Typography } from "antd";
import { motion } from "framer-motion";

import { CartItem } from "@/types";
import { formatCurrency } from "@/utils/format";

import { CartQuantityControl } from "./CartQuantityControl";

const { Paragraph, Text } = Typography;

interface CartDrawerItemProps {
  item: CartItem;
  isHighlighted?: boolean;
  onRemove: (productId: string) => void;
  onQuantityChange: (productId: string, quantity: number) => void;
}

export const CartDrawerItem = ({
  item,
  isHighlighted = false,
  onQuantityChange,
  onRemove,
}: CartDrawerItemProps) => (
  <motion.article
    layout
    initial={{ opacity: 0, x: 24 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: 24, height: 0, marginBottom: 0 }}
    transition={{ duration: 0.22 }}
    className={
      isHighlighted
        ? "cart-drawer-item cart-drawer-item--highlighted"
        : "cart-drawer-item"
    }
  >
    <img
      alt={item.name}
      className="cart-drawer-item__image"
      src={
        item.image ||
        "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=320&q=80"
      }
    />

    <div className="cart-drawer-item__content">
      <div className="cart-drawer-item__top">
        <Space size={[8, 8]} wrap>
          {item.karat ? <Tag color="gold">{item.karat}</Tag> : null}
          {isHighlighted ? <Tag color="green">Vừa thêm</Tag> : null}
        </Space>
        <Button
          aria-label={`Xóa ${item.name} khỏi giỏ hàng`}
          className="cart-drawer-item__remove"
          icon={<CloseOutlined />}
          size="small"
          type="text"
          onClick={() => onRemove(item.productId)}
        />
      </div>

      <div className="cart-drawer-item__copy">
        <Paragraph ellipsis={{ rows: 2 }} style={{ marginBottom: 0 }}>
          <Text strong>{item.name}</Text>
        </Paragraph>
        <div className="cart-drawer-item__price-line">
          <Text type="secondary">{formatCurrency(item.price)}</Text>
          <Text strong className="gold-text">
            {formatCurrency(item.price * item.quantity)}
          </Text>
        </div>
      </div>

      <div className="cart-drawer-item__footer">
        <CartQuantityControl
          quantity={item.quantity}
          productName={item.name}
          onDecrease={() =>
            onQuantityChange(item.productId, Math.max(1, item.quantity - 1))
          }
          onIncrease={() => onQuantityChange(item.productId, item.quantity + 1)}
        />
        <Text className="cart-drawer-item__quantity-note" type="secondary">
          Số lượng
        </Text>
      </div>
    </div>
  </motion.article>
);
